import styled, { css } from 'styled-components';
import { getSchemaState } from '../../../foundation/theme/palette.utils';
import { getRadius, getSpace } from '../../../foundation/theme/space.utils';
import { getFontWeight } from '../../../foundation/theme/typography.utils';
import { NOTIFICATION_TYPE_SCHEMA } from './Notification.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const NotificationRoot = styled.figure `
  ${({ theme, type, mode }) => {
    const { background, foreground } = getSchemaState({
        ...NOTIFICATION_TYPE_SCHEMA[type],
        theme,
        mode
    });
    return css `
      /* Fixed */
      align-items: baseline;
      border-radius: ${getRadius('m')};
      display: flex;
      margin: 0 0 ${getSpace('4xl')} 0;
      padding: ${getSpace('l')};

      /* Colors */
      background-color: ${background};
      color: ${foreground};

      /* Nested links */
      a {
        color: ${foreground};
        text-decoration: underline;
        font-weight: ${getFontWeight('black')};
      }
    `;
}}
`;
export const NotificationIcon = styled.div `
  ${({ theme, type, mode }) => {
    const { foregroundAlt } = getSchemaState({
        ...NOTIFICATION_TYPE_SCHEMA[type],
        theme,
        mode
    });
    return css `
      /* Fixed */
      margin-right: ${getSpace('s')};

      /* Colors */
      color: ${foregroundAlt};
    `;
}};
`;
export const NotificationContent = styled.div `
  flex: 1 1 auto;
`;
export const NotificationTitle = styled.figcaption `
  margin-bottom: ${getSpace('xs')};
`;
export const NotificationMessage = styled.div ``;
export const NotificationActions = styled.div `
  button {
    appearance: none;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
`;
//# sourceMappingURL=Notification.styled.js.map